module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'n6bnlhhz',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
